module.exports = __webpack_public_path__ + "static/california_univ-468ab407ba93e3065d697940b65be607.png";